export default function isDefaultLandingPage(defaultLandingPageUrl, path) {
  const { pathname } = window.location;
  const defaultPathname = defaultLandingPageUrl || '';
  return defaultPathname.endsWith(path || pathname);
}
